import { render, staticRenderFns } from "./ReviewsPageSettingsWidget.vue?vue&type=template&id=754f2949"
import script from "./ReviewsPageSettingsWidget.vue?vue&type=script&lang=js"
export * from "./ReviewsPageSettingsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports